import "./InfoBox.scss"

import { SvgIcon } from "@skylead/component-library"
import classNames from "classnames"
import React from "react"

const InfoBox = ({ children, className = "", noBackground = false }) => {
  const infoBoxClass = classNames("info-box", {
    [className]: className,
    "no-background": noBackground,
  })
  return (
    <div className={infoBoxClass}>
      <SvgIcon icon="info" className="round-icon" />
      {children}
    </div>
  )
}

// InfoBox.propTypes = {
//   children: PropTypes.node,
//   className: PropTypes.string,
//   noBackground: PropTypes.bool,
// }

export default InfoBox
